var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 340,
    viewBox: "0 0 249 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.636 30.9707H155.68V61.9269H186.636V30.9707Z",
    fill: "#D6FE7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7532 0H62.7827V30.9562H93.7532V0Z",
    fill: "#D6FE7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.234 278.663V339.661H0.855957V278.663H31.8121V247.707H62.7826V216.736H93.7388V154.81H62.7826V123.854H186.622V154.81H155.665V216.736H186.307V247.707H217.263V278.663H248.234Z",
    fill: "#D6FE7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.71 61.9268H93.7393V92.8829H124.71V61.9268Z",
    fill: "#D6FE7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor);
export default __webpack_public_path__ + "static/media/icon_color.929b7e739493641254ec4326e11b1c06.svg";
export { ForwardRef as ReactComponent };